<template>
  <div>
    <div>
      <b-form @submit.prevent="onSubmitDocumentsForm">
        <b-row>
          <b-col>
            <b-form-group id="input-group-1" label="Documento:" label-for="input-1">
              <b-form-select v-model="document.type" :options="documentsOptions" class="mb-3">
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="input-group-2" label="Fecha:" label-for="input-2">
              <b-form-input type="date" name="from_date" v-model="document.date"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-button class="mt-3 btn-block" :disabled="documentInvalid()" type="submit"
              variant="primary">Descargar</b-button>
          </b-col>
        </b-row>

        <b-modal ok-only v-model="showError" title="Error" header-bg-variant="danger" header-text-variant="light"
          ok-variant="light">
          <ul>
            <li>{{ messageError }}</li>
          </ul>
        </b-modal>

      </b-form>
    </div>
    <b-table :per-page="perPage" :current-page="currentPage" responsive v-if="files.length > 0" :fields="fileFields"
      :items="files" hover striped>
      <template #cell(file_name)="data">
        <a :href="'/employees/' + employee_id + '/files/' + data.item.file_id">{{ data.value }}</a>
      </template>
    </b-table>
    <b-pagination size="sm" :total-rows="files.length" v-model="currentPage" :per-page="perPage">
    </b-pagination>
    <h3 v-if="can('create', 'files')">Nuevo archivo</h3>
    <b-form-file v-if="can('create', 'files')" placeholder="Escoje un archivo..." v-model="newFile"></b-form-file>
    <b-form-group v-if="can('create', 'files')" horizontal label="Descripción">
      <b-form-input type="text" v-model="description"></b-form-input>
    </b-form-group>
    <b-button variant="success" v-if="fileSelected" @click="addNewSelectedFile">Subir</b-button>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { format } from 'date-fns';
import { Validation } from '../../utils';
export default {
  data() {
    return {
      showError:false,
      messageError:'',
      fileFields: [
        {
          key: 'file_name',
          label: 'Archivo',
        },
        {
          key: 'description',
          label: 'Descripción'
        }
      ],
      newFile: null,
      description: '',
      currentPage: 1,
      perPage: 8,

      document: {
        type: null,
        date: format(new Date(), 'YYYY-MM-DD'),
      },
      loading: false
    }
  },
  methods: {
    can: (action, resource) => {
      if (permissions === null) return false
      if (typeof (permissions[resource]) === 'undefined') return false
      return permissions[resource].includes(action)
    },
    documentInvalid() {
      return (!(!!this.document.type && !!this.document.date) || this.loading);
    },

    ...mapActions(['resetNewFiles', 'addNewFile']),
    ...mapMutations({
      updateFile: 'updateNewFileAttribute',
      create: 'creatingFile'
    }),
    addNewSelectedFile() {
      this.addNewFile({ file: this.newFile, description: this.description })
      this.newFile = null
      this.description = ''
    },
    onSubmitDocumentsForm() {
      this.getDocument(this.employee_id, this.document);
    },
    makeFileName(document) {
      const docItem = this.documents.find(d => d.id == document.type);
      return `${docItem.document} - (${this.code}) ${this.names} ${this.first_surname} ${this.second_surname}`.toUpperCase();
    },
    async getDocument(employee_id, Document) {
      this.loading = true;
      await axios({
        url: `/employees/${employee_id}/document`,
        method: 'POST',
        data: {
          type: Document.type,
          date: Document.date
        }
      }).then(response => {
        // FOR TEST ONLY
        /*const wblob = new Blob([response.data],{type: 'application/pdf'});
        const wurl = window.URL.createObjectURL(wblob);
        return window.open(wurl);*/
        const base64data = response.data;
        const downloadLink = window.document.createElement("a");
        downloadLink.href = 'data:application/pdf;base64,' + base64data;
        downloadLink.download = `${this.makeFileName(Document)}.pdf`;
        document.body.appendChild(downloadLink);
        downloadLink.click(); 
        document.body.removeChild(downloadLink);
      }).catch(e=>{
        this.showError = true;
        this.messageError = e.response.data.message;

      });
      this.loading = false;
    },

  },
  computed: {
    ...mapGetters({
    }),
    ...mapState({
      employee_id: state => state.employeeManager.employee.id,
      names: state => state.employeeManager.employee.names,
      first_surname: state => state.employeeManager.employee.first_surname,
      second_surname: state => state.employeeManager.employee.second_surname,
      code: state => state.employeeManager.employee.code,
      files: state => state.employeeManager.employee.files,
      state: state => state.employeeManager.fileState,
      features: state => state.employeeManager.features,
      documents: state => state.employeeManager.documents,
    }),
    fileSelected() {
      return this.newFile != null
    },
    documentsOptions() {
      return [{ text: 'Elija un documento', value: null }]
        .concat(this.documents.map(e => {
          return {
            'text': e.document,
            'value': e.id
          };
        }));
    },
  }

}
</script>
